import { getCountryByCode } from 'components/Form/countryCodes'
import {
  CreateLocationProps,
  GooglePlaceResult,
  LocationFormikOnlyValues,
  LocationPreFillData,
  UpdateLocationProps,
} from 'types/location'
import { preFillForm } from './helpers'

export const getPrefillData = (
  addressComponents: GooglePlaceResult['address_components']
): Partial<LocationPreFillData> => {
  if (!addressComponents) return {}
  const preFillData = addressComponents.reduce(
    (acc, { short_name, long_name, types }) => {
      const componentTypes = new Set<string>(types)
      if (componentTypes.has('street_number')) {
        acc.addressLine = long_name + ' ' + (acc.addressLine ?? '').trim()
      } else if (componentTypes.has('route')) {
        acc.addressLine = (acc.addressLine ?? '').trim() + ' ' + short_name
      } else if (
        ['postal_town', 'locality', 'sublocality_level_1'].some((type) =>
          componentTypes.has(type)
        )
      ) {
        acc.city = long_name
      } else if (componentTypes.has('administrative_area_level_1')) {
        acc.state = short_name
      } else if (componentTypes.has('postal_code')) {
        acc.zip = short_name
      } else if (componentTypes.has('country')) {
        acc.countryCode = short_name
      }
      return acc
    },
    {} as LocationPreFillData
  )
  if (preFillData.countryCode) {
    preFillData.__country = getCountryByCode(preFillData.countryCode)
  }
  if (preFillData.addressLine) {
    preFillData.addressLine = preFillData.addressLine.trim()
  }
  return preFillData
}

export const preFillFormWithPlace = (
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void,
  place: GooglePlaceResult
) => {
  if (place.address_components) {
    const preFillData = getPrefillData(place.address_components)
    preFillForm(setFieldValue, preFillData)
    setFieldValue(
      '__googleData',
      {
        lat: place.geometry?.location?.lat(),
        long: place.geometry?.location?.lng(),
        place_id: place.place_id,
        preFillData: preFillData,
      },
      false
    )
  }
}

export const validatePlaceData = (
  location: (CreateLocationProps | UpdateLocationProps) &
    LocationFormikOnlyValues
) => {
  const googleData = location.__googleData
  if (
    googleData &&
    (Object.entries(googleData.preFillData) as [
      keyof LocationPreFillData,
      any
    ][]).every(([key, val]) => {
      return location[key] === val
    })
  ) {
    location.coordinates = {
      lat: String(googleData.lat),
      long: String(googleData.long),
    }
  } else {
    location.coordinates = {}
  }
}

export const googlePlacesPrefillFields = [
  'addressLine',
  'city',
  'countryCode',
  'state',
  'zip',
] as (keyof LocationPreFillData)[]
